import { render } from "./ResidentialDetails.vue?vue&type=template&id=f6613730&scoped=true&ts=true"
import script from "./ResidentialDetails.vue?vue&type=script&lang=ts"
export * from "./ResidentialDetails.vue?vue&type=script&lang=ts"

import "./ResidentialDetails.vue?vue&type=style&index=0&id=f6613730&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6613730"],['__file',"src/components/kyc/ResidentialDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6613730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6613730', __exports__)) {
    api.reload('f6613730', __exports__)
  }
  
  module.hot.accept("./ResidentialDetails.vue?vue&type=template&id=f6613730&scoped=true&ts=true", () => {
    api.rerender('f6613730', render)
  })

}


export default __exports__